import React, { useState } from "react";
import axios from "axios";
import { API_ENDPOINTS } from "../config/api";
import { useLocation, useNavigate } from "react-router-dom";
import { persistAuthToken } from "../utils/adminApi";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(
        API_ENDPOINTS.login,
        credentials,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200 && response.data.token) {
        persistAuthToken(response.data.token);
        navigate(location.state?.from?.pathname || "/dashboard");
      } else {
        setError("Login failed. Invalid credentials.");
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError("Invalid email or password. Please try again.");
    }
  };

  return (
    <div className="container my-5">
      <section className="text-center mb-4">
        <h1 className="fw-bold">Login</h1>
        <p>Access your account by entering your credentials below.</p>
      </section>

      <div className="row justify-content-center">
        <div className="col-md-4">
          <form
            className="p-4 border rounded shadow-sm bg-light"
            onSubmit={handleSubmit}
          >
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
              <label className="form-label">Email Address</label>
              <input
                name="email"
                type="email"
                className="form-control"
                placeholder="Enter Email"
                required
                value={credentials.email}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                name="password"
                type="password"
                className="form-control"
                placeholder="Enter Password"
                required
                value={credentials.password}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="btn btn-primary w-100">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
